<template>
    <div>
        <div class="ibox animated fadeInLeftBig">
            <div class="ibox-title" style="padding:16px;">
                <h3>
                    {{crudName}}

                    <button type="button" class="btn btn-success" v-show="enableExport"
                            @click="exportRecords" style="float:right;margin-top:-5px;margin-left:8px;">
                        Exportar <i class="fa fa-download"></i>
                    </button>
                    <router-link :to="prepareUrl(endPoint) + 'add'" class="btn btn-primary" v-show="enableAdd"
                                 style="float:right;margin-top:-5px;">{{newText}}
                    </router-link>
                </h3>
            </div>

            <div class="ibox-content">
                <v-server-table ref="table" :name="table" :url="url" :columns="columns" :options="options">
                    <div slot="actions" slot-scope="props">
                        <a v-show="enableView" data-toggle="tooltip" title="Consultar" class="btn btn-info    fa fa-eye"
                           @click="view(props.row.id)" style="margin-bottom:3px;"></a>
                        <a v-show="enableEdit" data-toggle="tooltip" title="Editar" class="btn btn-warning fa fa-pencil"
                           @click="edit(props.row.id)" style="margin-bottom:3px;"></a>
                        <a v-show="enableDelete" data-toggle="tooltip" title="Deletar"
                           class="btn btn-danger  fa fa-trash" @click="destroy(props, props.row, props.index)"
                           style="margin-bottom:3px;"></a>
                        <a v-show="enableSetStatus" data-toggle="tooltip" title="Ativa/Inativa"
                           class="btn btn-success fa fa-check" @click="active(props, props.row, props.index)"
                           style="margin-bottom:3px;"></a>
                        <a v-show="enableSetTestNotification" data-toggle="tooltip" title="Notificações de Teste"
                           class="btn btn-success fa fa-paper-plane" @click="setTestNotification(props, props.row, props.index)"
                           style="margin-bottom:3px;"></a>
                        <a v-show="boxUpload" data-toggle="tooltip" title="Upload"
                           class="btn btn-danger fa fa-upload"
                           @click="uploadBoxImage(props, props.row, props.index)" style="margin-bottom:3px;"></a>

                        <template v-for="extra in extra">
                            <a data-toggle="tooltip" :title="extra.title" :key="extra.id"
                               :class="extra.class" @click="callExtra(extra.name, props, props.row, props.index)"
                               style="margin-bottom:3px;">
                                {{extra.label}}
                            </a>
                        </template>

                    </div>
                    <div slot="box_photo" slot-scope="props" v-bind:id="'box-' + props.row.id">
                        <img :src="props.row.box_photo" alt="" class="photo" style="width:80px">
                        <span>{{ props.row.box_photo }}</span>
                    </div>
                    <div slot="photo" slot-scope="props">
                        <img :src="props.row.photo" alt="" class="photo" width="100%">
                    </div>
                    <div slot="cover_photo" slot-scope="props">
                        <img :src="props.row.cover_photo" alt="" class="photo" width="100%">
                    </div>
                </v-server-table>
            </div>
        </div>

    </div>
</template>

<script>
    import {Pagination} from 'vue-pagination-2';

    export default {
        data: function () {
            return {
                records: [],
                pages: [],
                tableData: [],
            }
        },
        props: {
            crudName: String,
            newText: String,
            table: String,
            columns: Array,
            options: Object,
            endPoint: String,
            enableAdd: Boolean,
            enableEdit: Boolean,
            enableDelete: Boolean,
            enableView: Boolean,
            enableSetStatus: Boolean,
            enableSetTestNotification: Boolean,
            enableExport: Boolean,
            exportEndpoint: String,
            boxUpload: Boolean,
            extra: Array
        },
        computed: {
            url() {
                let aux = (this.endPoint.includes('?')) ? '&disabled=true' : '?disabled=true';
                return this.$store.getters.api + this.endPoint + aux;
            }
        },
        methods: {
            refresh() {
                console.info("BaseCrud refresh called");
                this.$refs.table.refresh();
            },
            callExtra(name, props, row, index) {
                this.$emit(name, {
                    props, row, index
                })
            },
            edit(id) {
                this.$router.push({
                    path: this.prepareUrl(this.endPoint) + 'edit/' + id
                });
            },
            view(id) {
                this.$router.push({
                    path: this.prepareUrl(this.endPoint) + 'view/' + id
                });
            },
            destroy(props, row, index) {
                const self = this;

                swal({
                    title: "Deseja deletar o registro?",
                    text: "Essa operação não pode ser desfeita",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, deletar!",
                    showLoaderOnConfirm: true,
                    buttons: {
                        catch: {
                            text: "Não",
                            value: "cancel",
                            className: "btn-danger"
                        },
                        confirm: {
                            text: "Sim",
                            value: 'confirm'
                        }
                    },
                })
                    .then((value) => {
                        switch (value) {
                            case 'cancel':
                                swal('Cancelado', 'O registro não foi excluido!', 'info');
                                break;
                            case 'confirm':
                                self.$http.delete(this.prepareUrl(this.url) + row.id, {
                                    'id': row.id
                                })
                                    .then((response) => {
                                        const tableData = self.$refs.table.tableData;
                                        tableData.splice(tableData.indexOf(tableData.find((o) => o.id === row.id)), 1);
                                        swal('Sucesso', 'Registro excluído com sucesso!', 'success');
                                    });
                                break;
                        }
                    });
            },
            active(props, row, index) {
                const self = this;

                swal({
                    title: "Mudança de Status",
                    text: "Deseja ativar/inativar o registro?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim",
                    showLoaderOnConfirm: true,
                    buttons: {
                        catch: {
                            text: "Não",
                            value: "cancel",
                            className: "btn-danger"
                        },
                        confirm: {
                            text: "Sim",
                            value: 'confirm'
                        }
                    },
                })
                    .then((value) => {
                        switch (value) {
                            case "cancel":
                                swal("Cancelado", "Ação cancelada!", "info");
                                break;
                            case "confirm":
                                row.status = (row.status === 2) ? 1 : 2;

                                self.$http
                                    .put(this.prepareUrl(this.url) + row.id, {
                                        status: row.status
                                    })
                                    .then(response => {
                                        swal("Sucesso", "Registro alterado com sucesso!", "success");
                                    });
                                break;
                        }
                    });
            },
            setTestNotification(props, row, index) {
                const self = this;

                swal({
                    title: "Mudança de Status",
                    text: "Deseja ativar/inativar recebimento de notificações de teste?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim",
                    showLoaderOnConfirm: true,
                    buttons: {
                        catch: {
                            text: "Não",
                            value: "cancel",
                            className: "btn-danger"
                        },
                        confirm: {
                            text: "Sim",
                            value: 'confirm'
                        }
                    },
                })
                    .then((value) => {
                        switch (value) {
                            case "cancel":
                                swal("Cancelado", "Ação cancelada!", "info");
                                break;
                            case "confirm":
                                row.test_notifications = !row.test_notifications;
                                self.$http
                                    .put(this.prepareUrl(this.url) + row.id, {
                                        test_notifications: row.test_notifications
                                    })
                                    .then(response => {
                                        swal("Sucesso", "Registro alterado com sucesso!", "success");
                                    });
                                break;
                        }
                    });
            },
            uploadBoxImage(props, row, index) {
                let modal = $('#uploadBoxImage');

                modal.find('#id').val(row.id);
                modal.modal('show');
            },
            prepareUrl(url) {
                if (url.includes('?')) {
                    return url.split('?')[0];
                }

                return url;
            },
            exportRecords() {
                const endpoint = this.exportEndpoint || (this.prepareUrl(this.endPoint) + 'export');
                const self = this;

                self.$http.get(self.$store.getters.api + endpoint, {
                    responseType: 'blob'
                }).then((response) => {
                    if (!response.data || response.data.size === 0) {
                        self.$message(null, 'O arquivo de exportação veio vazio.', 'error');
                        return;
                    }

                    const disposition = response.headers['content-disposition'] || '';
                    const match = disposition.match(/filename="?([^"]+)"?/i);
                    const filename = match ? match[1] : 'usuarios.xlsx';
                    const url = window.URL.createObjectURL(new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }));
                    const link = document.createElement('a');

                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                }).catch((error) => {
                    self.$error(error);
                });
            }
        },
        components: {
            Pagination
        }
    }
</script>

<style scoped>

    .photo {
        max-height: 180px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Base/BaseCrud.vue